import { Link } from "react-router-dom";
import { rumors } from "@/mocks/rumors";
import { popularTags } from "@/mocks/categories";
import ArticleCard from "@/components/feature/ArticleCard";
import { formatHeat } from "@/utils/format";

export default function StreamSection() {
  const stream = rumors.slice(0, 6);
  const ranking = [...rumors].sort((a, b) => b.heat - a.heat).slice(0, 6);

  return (
    <section className="py-14 md:py-16">
      <div className="container-editorial">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-8">
            <div className="mb-6 flex items-end justify-between gap-4">
              <div>
                <span className="mb-2 inline-flex items-center gap-2 text-xs font-medium tracking-[0.18em] text-primary-600 uppercase">
                  <span className="h-px w-6 bg-primary-500" />
                  Latest Drops
                </span>
                <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-[28px]">
                  最新爆料流
                </h2>
              </div>
              <Link
                to="/rumors"
                className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
              >
                查看全部
                <i className="ri-arrow-right-line text-base" />
              </Link>
            </div>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {stream.map((item, index) => (
                <ArticleCard key={item.id} rumor={item} variant="grid" index={index} />
              ))}
            </div>
          </div>

          <aside className="lg:col-span-4">
            <div className="sticky top-28 space-y-5">
              <div className="rounded-lg border border-background-200/80 bg-background-100/60 p-5">
                <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                  <i className="ri-bar-chart-2-line text-primary-600" />
                  爆料热度排行
                </h3>
                <ol className="mt-4 space-y-3">
                  {ranking.map((item, index) => (
                    <li key={item.id} className="flex items-start gap-3">
                      <span
                        className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded font-heading text-xs font-bold ${
                          index < 3
                            ? "bg-primary-600 text-background-50"
                            : "bg-background-300 text-foreground-700"
                        }`}
                      >
                        {index + 1}
                      </span>
                      <div className="min-w-0">
                        <Link
                          to={`/article/${item.id}`}
                          className="block text-sm leading-snug text-foreground-800 transition-colors hover:text-primary-700 line-clamp-2"
                        >
                          {item.title}
                        </Link>
                        <span className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                          <span className="flex items-center gap-1 text-primary-600">
                            <i className="ri-fire-line" />
                            {formatHeat(item.heat)}
                          </span>
                          {item.categoryName}
                        </span>
                      </div>
                    </li>
                  ))}
                </ol>
              </div>

              <div className="rounded-lg border border-background-200/80 bg-background-50 p-5">
                <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                  <i className="ri-hashtag text-secondary-600" />
                  热门标签
                </h3>
                <div className="mt-3.5 flex flex-wrap gap-2">
                  {popularTags.map((tag) => (
                    <Link
                      key={tag}
                      to={`/rumors?q=${encodeURIComponent(tag)}`}
                      className="rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-800 transition-colors hover:bg-secondary-200"
                    >
                      {tag}
                    </Link>
                  ))}
                </div>
              </div>

              <div className="rounded-lg border border-accent-300 bg-accent-50 p-5">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                  <i className="ri-shield-user-line text-lg" />
                </span>
                <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">我们如何核实线索</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                  每条爆料至少经过两个独立信源的交叉比对，无法验证的部分会明确标注，不作定论。
                </p>
                <Link
                  to="/about"
                  className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-accent-800 transition-colors hover:text-accent-900"
                >
                  了解内容原则
                  <i className="ri-arrow-right-line text-base" />
                </Link>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}